import { UPDATE_DIAGNOSIS_RESULT, RESET_DIAGNOSIS_RESULT } from '../constants';

const updateDiagnosisResult = data => ({
  type: UPDATE_DIAGNOSIS_RESULT,
  payload: data,
});
export const resetDiagnosisResult = () => ({
  type: RESET_DIAGNOSIS_RESULT,
});

export default updateDiagnosisResult;



// WEBPACK FOOTER //
// ./src/redux/actions/diagnosisResult.js